var els = $('[data-document-requirements], .document-requirements-container');
if (els.length > 0) {
  require.ensure('../controllers/document_requirements_controller', function(
    require
  ) {
    var DocumentRequirementsController = require('../controllers/document_requirements_controller');
    els.each(function() {
      return new DocumentRequirementsController(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/document_requirements.initializer.js